import { AccountType } from '@/data/usecases/account/account-type'
import { AccountModel } from '@/domain/models/account/account-model'
import { DocumentType } from '@/domain/models/document/document-type'

export const showUpgradeRequestButton = (account: AccountModel): boolean => {
  if (
    account.passPlan &&
    (account.passPlan.id as number) < 5 &&
    AccountType.Enum.COLLABORATOR.is(account) &&
    account.company.allowUpgrade &&
    DocumentType.Enum.CPF.is(account.document)
  ) {
    return true
  }
  return false
}
